import { SelectUserCommandExecutor } from './select-user-command-executor';
import { FilterCommandExecutor } from './filter-command-executor';
import { SearchCommandExecutor } from './search-command-executor';
import { SelectLocationCommandExecutor } from './select-location-command-executor';
import { SelectAccountCommandExecutor } from './select-account-command-executor';
import * as TSE from 'ts-events';
import { Gui } from './../gui';

export class CommandManager {
    public selectUserCommandExecutor: SelectUserCommandExecutor;
    public selectAccountCommandExecutor: SelectAccountCommandExecutor;
    public filterCommandExecutor: FilterCommandExecutor;
    public searchCommandExecutor: SearchCommandExecutor;

    public selectLocationCommandExecutors: SelectLocationCommandExecutor[] = [];

    public createdLocationCommand = new TSE.SyncEvent();

    constructor(private gui: Gui) {
        // register the select user command, but don't select any (null)
        this.selectUserCommandExecutor = new SelectUserCommandExecutor();
        this.selectAccountCommandExecutor = new SelectAccountCommandExecutor();
        this.filterCommandExecutor = new FilterCommandExecutor();
        this.searchCommandExecutor = new SearchCommandExecutor();
    }

    public deleteLocationCommand = (el: SelectLocationCommandExecutor) => {
        el.delete();
        el.requestReset();
        this.selectLocationCommandExecutors.splice(this.selectLocationCommandExecutors.indexOf(el), 1);
    }

    public addLocationCommandExecutor() {
        let executor = new SelectLocationCommandExecutor(this.gui);
        this.selectLocationCommandExecutors.push(executor);
        this.createdLocationCommand.post(executor);
        return executor;
    }
}
